import React, { useMemo } from 'react';
import { sanitizeHtml } from '../lib/safeHtml';

export const SafeHtml = ({ html, ...props }) => {
  const clean = useMemo(() => sanitizeHtml(html), [html]);
  return <div {...props} dangerouslySetInnerHTML={{ __html: clean }} />;
};
